module.exports = __webpack_public_path__ + "static/media/poste_29.61a6b4eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_29.jpg
// module id = 258
// module chunks = 0